import { Box, Typography } from '@mui/material';

import WaitImage from 'assets/images/maintenance/loading-rpl.gif';

export default function WaitCard({ title, subtitle = '', imgStyle = { width: 350, height: 350 } }) {
    imgStyle = { height: '230px', ...imgStyle };
    return (
        <Box sx={{ width: '100%', textAlign: 'center' }}>
            <img src={WaitImage} alt="Please wait.." draggable={false} style={imgStyle} />
            <Typography variant="h1" className="main-font-b">
                {title || 'Please Wait..'}
            </Typography>
            <Typography
                variant="body1"
                component="span"
                className="main-font"
                dangerouslySetInnerHTML={{ __html: subtitle || 'We are working on it. This will only take a moment.' }}
            ></Typography>
        </Box>
    );
}
